export default "__VITE_ASSET__CAr2Tw4M__"